import { Stack } from '@mui/material';
import { useRecoilValueLoadable } from 'recoil';

import { FullScreen } from '../../components/FullScreen';
import { IncidentTable } from '../../components/IncidentTable';
import { IncidentUpdates } from '../../components/IncidentUpdates';
import { ControlPanel } from '../../entities/incident/grid';
import { FontSizeControl } from '../../features/grid-settings';
import { userState } from '../../state/user';

const Incidents = () => {
  const currentUser = useRecoilValueLoadable(userState).valueMaybe();

  if (!currentUser) {
    return null;
  }

  return (
    <FullScreen>
      <Stack
        sx={{
          height: '100%',
          background: '#ffffff',
        }}
      >
        <ControlPanel fontSizeControl={<FontSizeControl gridType='incident' />} />
        <IncidentTable />
        <IncidentUpdates />
      </Stack>
    </FullScreen>
  );
};

export default Incidents;
